import General from '../../contents/General'
import Management from '../../contents/Management'
import Fuel from '../../contents/Fuel'
import OrderManagement from '../../contents/OrderManagement'
import Expense from '../../contents/Expense'
import CustomizationDashboard from '../../contents/CustomizationDashboard.vue'
import DatabricksDashboard from '../../contents/DatabricksDashboard.vue'

function dashboardTabs(instance) {
  return [
    {
      key: 'vehicle',
      hash: '#vehicle',
      title: instance.$t('dashboard.tab.vehicle'),
      showTab: true,
      content: General,
      isNewSubmodule: () => {
        return instance.isNewSubmodule('a1a-dasbor-statuskendaraan')
      },
    },
    {
      key: 'management',
      hash: '#management',
      title: instance.$t('dashboard.tab.summary'), //Before is dashboard.tab.management
      showTab: instance.hasAccess(['a7a-summary-trip-cost:read', 'a7b-trip-analysis:read']),
      content: Management,
      isNewSubmodule: () => {
        return instance.isNewSubmodule('a7a-summary-trip-cost')
      },
    },
    {
      key: 'fuel',
      hash: '#fuel',
      title: instance.$t('dashboard.tab.fuel'),
      showTab:
        instance.hasAccess([
          'total_fuel_consumption:read',
          'dasbor_alert_fuel:read',
          'dasbor_top20_fuel_efficiency:read',
          'dasbor_daily_fuel_comparison:read',
          'dasbor_monthly_fuel_comparison:read',
          'dasbor_monthly_total_not_efficiency:read',
          'dasbor_monthly_fuel_loss:read',
        ]) && !instance.hasAccess(['hide-fuel-dashboard-report:read']),
      content: Fuel,
      submodule_alias: 'a6a-fuelusage',
      isNewSubmodule: () => {
        return instance.isNewSubmodule('a6a-fuelusage')
      },
    },
    {
      key: 'delivery',
      hash: '#delivery',
      title: instance.$t('dashboard.tab.delivery'),
      showTab: instance.hasAccessAll(['tms:create', 'tms:read', 'tms:update', 'tms:delete']),
      submodule_alias: 'tms-main',
      content: OrderManagement,
      isNewSubmodule: () => {
        return instance.isNewSubmodule('tms-main')
      },
    },
    {
      key: 'expense',
      hash: '#expense',
      title: instance.$t('dashboard.tab.expense'),
      showTab: instance.hasAccessAll([
        'financial-record:create',
        'financial-record:read',
        'financial-record:update',
        'financial-record:delete',
        'tms:create',
        'tms:read',
        'tms:update',
        'tms:delete',
      ]),
      content: Expense,
    },
    {
      key: 'customizationdashboard',
      hash: '#customizationdashboard',
      title: instance.$t('dashboard.tab.customization'),
      showTab: instance.hasAccess(['a1g-dasbor-externalcontent:read']),
      content: CustomizationDashboard,
    },
    {
      key: 'databricks',
      hash: '#databricks',
      title: instance.$t('dashboard.tab.databricks'),
      showTab: instance.hasAccess(['a1h-dasbor-databricks:read']),
      content: DatabricksDashboard,
      isNewSubmodule: () => false,
    },
  ]
}

export default dashboardTabs
